module.exports = __webpack_public_path__ + "img/tier1_pic2.0b608da8.png";